module.exports = __webpack_public_path__ + "static/media/kh.5b110315.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/kh.svg
// module id = 162
// module chunks = 0